import { render } from "./SubscriptionVamZaim.vue?vue&type=template&id=2c32d6ef&scoped=true"
import script from "./SubscriptionVamZaim.vue?vue&type=script&lang=js"
export * from "./SubscriptionVamZaim.vue?vue&type=script&lang=js"

import "./SubscriptionVamZaim.vue?vue&type=style&index=0&id=2c32d6ef&scoped=true&lang=css"
import "./SubscriptionVamZaim.vue?vue&type=style&index=1&id=2c32d6ef&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c32d6ef"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QSelect});
